export const APP_DATA_FETCH_RETRY = 'APP_DATA_FETCH_RETRY';
export const FORMS_DATA_FETCH_RETRY = 'FORMS_DATA_FETCH_RETRY';
export const MAZE_FETCH_RETRY = 'MAZE_FETCH_RETRY';
export const CLPL_FETCH_RETRY = 'CLPL_FETCH_RETRY';
export const TRCO_FETCH_RETRY = 'TRCO_FETCH_RETRY';
export const LC_FETCH_RETRY = 'LC_FETCH_RETRY';
export const VOCAB_TQVM_FETCH_RETRY = 'TQVM_FETCH_RETRY';
export const VOCAB_FITB_FETCH_RETRY = 'FITB_FETCH_RETRY';
export const VOCAB_BD_FETCH_RETRY = 'BD_FETCH_RETRY';
export const SPELLING_FETCH_RETRY = 'SPELLING_FETCH_RETRY';
export const RAN_FETCH_RETRY = 'RAN_FETCH_RETRY';
export const WR_FETCH_RETRY = 'WR_FETCH_RETRY';
export const BOOK_METADATA_FETCH_RETRY = 'BOOK_METADATA_FETCH_RETRY';
